import { Interval, Workout } from "./Workout";

export default class WorkoutPlayer
{
    private _Workout: Workout;
    public get Workout(): Workout { return this._Workout };
    constructor(workout: Workout)
    {
        this._Workout = workout;
    }

    CurrentTime: number = 0;
    Ftp: number = 100;

    private IsStarted: boolean = false;
    
    get CurrentPowerNormalized(): number | undefined 
    {
        const currentInterval = this.CurrentInterval;
        if (currentInterval === undefined) return undefined;
        const secondsSinceBeginningOfTheInterval = this.CurrentTime - this.TimeAtBeginningOfCurrentInterval!;
        const targetPower = currentInterval.GetTargetPowerAtTime(secondsSinceBeginningOfTheInterval);
        if (targetPower === undefined) return undefined;

        return Math.round(this.NormalizePower(targetPower));
    }
    
    get CurrentCadence(): number | undefined 
    {
        return this.CurrentInterval?.TargetCadence;
    }
    
    get CurrentInterval(): Interval | undefined
    {
        if (!this.IsStarted || this.CurrentTime < 0) {
            return undefined;
        }
        let startOfCurrentInterval = 0;
        for(let interval of this._Workout.Intervals)
        {
            if (this.CurrentTime < startOfCurrentInterval + interval.TotalSeconds) {
                return interval;
            }
            startOfCurrentInterval += interval.TotalSeconds;
        }
    }

    get TimeAtBeginningOfCurrentInterval(): number | undefined
    {
        if (!this.CurrentInterval)
            return undefined;
        const intervals = this._Workout.Intervals;
        let sum = 0;
        for (let i = 0; i < intervals.length; i++)
        {
            if (this.CurrentInterval == intervals[i])
                break;
            
            sum += intervals[i].TotalSeconds;
        }

        return sum;
    }

    startWorkout()
    {
        this.CurrentTime = 0;
        this.IsStarted = true;
    }

    NormalizePower(power: number)
    {
        return Math.round(power * this.Ftp / 100);
    }

}